import { observer } from "mobx-react-lite";
import { useFormikContext } from "formik";
import { useTran } from "@/hooks";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";
import { EMPLOYEE_RANGE, ANNUAL_REVENUE } from "@/lib/constants";

const ChoiceGrid = ({ id, label, options, value, onChange, error }) => (
  <div className="space-y-2">
    <Label className="block font-medium text-foreground">
      {label}
      <span className="text-destructive ml-1">*</span>
    </Label>
    <RadioGroup
      value={value}
      onValueChange={onChange}
      className="grid gap-3 sm:grid-cols-2"
    >
      {(options || []).map((option) => (
        <label
          key={`${id}-${option}`}
          className={cn(
            "flex items-center gap-3 rounded-radius border px-3 py-3 text-sm transition",
            value === option
              ? "border-primary bg-primary/10"
              : "border-border hover:bg-muted/50",
          )}
        >
          <RadioGroupItem value={option} id={`${id}-${option}`} />
          <span className="font-medium text-foreground">{option}</span>
        </label>
      ))}
    </RadioGroup>
    {error ? <p className="text-sm text-destructive">{error}</p> : null}
  </div>
);

const CompanySetupStepThree = observer(() => {
  const { t } = useTran();
  const { values, touched, errors, setFieldValue, setFieldTouched } =
    useFormikContext();

  const getFieldError = (key) => (touched?.[key] ? errors?.[key] : undefined);

  const handleEmployeesChange = (value) => {
    setFieldValue("employeesRange", value, true);
    setFieldTouched("employeesRange", true, false);
  };

  const handleRevenueChange = (value) => {
    setFieldValue("revenueRange", value, true);
    setFieldTouched("revenueRange", true, false);
  };

  return (
    <div className="space-y-6">
      <ChoiceGrid
        id="employeesRange"
        label={t("How many employees do you have?")}
        options={EMPLOYEE_RANGE}
        value={values.employeesRange}
        onChange={handleEmployeesChange}
        error={getFieldError("employeesRange")}
      />
      <ChoiceGrid
        id="revenueRange"
        label={t("What is your annual revenue in USD?")}
        options={ANNUAL_REVENUE}
        value={values.revenueRange}
        onChange={handleRevenueChange}
        error={getFieldError("revenueRange")}
      />
    </div>
  );
});

export default CompanySetupStepThree;
